export const VIP_TIERS_CONDITION_TYPES = {
    points: "earn_points",
    purchasesMade: "purchases_made",
    spentAmount: "spent_amount",
    customerTag: "customer_tag",
    completedReferrals: "completed_referrals",
} as const;
